export default __webpack_public_path__ + "static/media/auth-password.b5ca058d.png";